import { useEffect, useState } from 'react';
import { textCall } from '../../../constants/texts';
import { formatTime } from '../utils/format-time';
export const useTimer = () => {
    const [currentSeconds, setCurrentSeconds] = useState(0);
    const [isActiveTimer, setIsActiveTimer] = useState(false);
    const getFormatterTimeOrDefaultText = () => currentSeconds ? formatTime(currentSeconds) : textCall.BEFORE_ACTIVE_TIMER;
    const clearTimer = () => {
        setIsActiveTimer(false);
        setCurrentSeconds(0);
    };
    useEffect(() => {
        let interval;
        if (isActiveTimer) {
            interval = setInterval(setCurrentSeconds, 1000, currentSeconds + 1);
        }
        else {
            setIsActiveTimer(false);
        }
        return () => {
            clearInterval(interval);
        };
    }, [currentSeconds, isActiveTimer]);
    return {
        currentSeconds,
        isActiveTimer,
        clearTimer,
        setIsActiveTimer,
        timerText: getFormatterTimeOrDefaultText(),
    };
};
